export { default } from './ShelfAddTitleButton';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfAddTitleButton/index.js